import styled, { css } from 'styled-components';
import Icon from '../../_shared/components/Icon';

export const StyledNotificationsContainer = styled.div`
  position: relative;
  margin: 0 40px;
  cursor: pointer;
  ${({ isOmp }) =>
    isOmp &&
    css`
      margin: 0 0 0 12px;
    `}
`;

export const StyledNotificationIcon = styled(Icon).attrs({
  style: {
    display: 'block'
  }
})`
  width: 18px;
  height: 45px;
  & > path {
    fill: ${({ theme }) => theme.COLORS.BASE};
  }
  ${({ isOmp }) =>
    isOmp &&
    css`
      -webkit-filter: invert(100%);
    `}
`;

export const StyledNotificationBadge = styled.span`
  position: absolute;
  width: 12px;
  height: 12px;
  top: 11px;
  left: 17px;
  border-radius: 50%;
  background: ${({ theme }) => theme.COLORS.RED};
  ${({ isOmp }) =>
    isOmp &&
    css`
      width: 6px;
      height: 6px;
    `}
`;
